import { createPopper } from '@popperjs/core';
export default {
  props: {
    placement: {
      type: String,
      "default": 'bottom-end'
    },
    autoClose: {
      type: Boolean,
      "default": true
    }
  },
  data: function data() {
    return {
      show: false
    };
  },
  watch: {
    show: function show(_show) {
      var _this = this;
      if (_show) {
        this.$nextTick(function () {
          _this.popper = createPopper(_this.$el, _this.$refs.dropdown, {
            placement: _this.placement,
            modifiers: [{
              name: 'preventOverflow',
              options: {
                altBoundary: true
              }
            }]
          });
        });
      } else if (this.popper) {
        setTimeout(function () {
          return _this.popper.destroy();
        }, 100);
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        _this2.show = false;
      }
    });
  }
};